'use strict';


angular.module('shiftTraderApp')
    .controller('BaseQuerySubscriptionCtrl', ['$scope', 'NotesQueryManagementService', function ($scope, NotesQueryManagementService) {

      /* Usage (ctrl = instance of this controller)
       * --- Initialization
       * ctrl.initialize(componentName, managementId)  => Get this controller subscribed and initialized.
       * ctrl.uninitialize()  => Disposes of this controller's query update subscription.
       * ctrl.setRenderCallback(clbk)  => Sets the function to be called when a query update is intercepted.
       *   The render callback will be supplied the current query as its first and only argument.
       * ctrl.updateMyself()  => Fetches the latest query and calls the render callback. This will be called
       *   Called automatically when a query update event is intercepted, but not on initialization.
       *
       * --- Runtime
       * ctrl.setQuery(query)  =>  Updates this query and trigger query update event.
       * ctrl.getQuery()  => Gets the current query
       */

      var that = this;

      // Fields
      this.subscriberName = '(Uninitialized subscriber)';
      this.render = function() { console.warn('Tried to call render for ' + that.subscriberName + ', but no render callback was set!'); };
      this.subscription = { uninitialized: 'Subscription was not initialized! Don\'t forget to run initialize()!' };
      this.channel = undefined;
      this.managementId = null;

      // Public methods
      this.setQuery = function(query) {
        if (that.subscription) {
          that.subscription.query = query;
          registerQueryChange();
        } else {
          console.error(that.subscriberName + ': Could not set query, subscription was not initialized.');
        }
      };

      this.getQuery = function() {
        if (that.subscription) {
          return that.subscription.query;
        } else {
          console.error(that.subscriberName + ': Failed to get query, not initialized. Be sure you\'re calling initialize()!');
        }
      };

      this.setRenderCallback = function(clbk) {
        if (typeof(clbk) == 'function') {
          that.render = clbk;
        } else {
          console.error(that.subscriberName + ': Query render callback was of type ' + typeof(clbk) + ', expected function.');
        }
      };

      this.updateMyself = function() {
        updateMyQueryFromQueryManagementService();

        if (that.subscription.query) {
          if (that.render) {
            that.render(that.subscription.query);
          } else {
            console.error(that.subscriberName + ': No render callback registered.');
          }
        } else {
          console.error(that.subscriberName + ': Tried to call render without being initialized.');
        }
      };

      this.initialize = function(componentName, managementId) {
        if (!that.initialized) {
          that.initialized = true;
          that.subscriberName = componentName.toString();
          that.managementId = managementId.toString();
          updateMyQueryFromQueryManagementService();
          subscribeToUpdates();

          $scope.$on('$destroy', function() {
            unsubscribeFromChannel();
          });
        } else {
          console.warn(that.subscriberName + ': Attempted to re-initialize.');
        }
      };

      this.uninitialize = function() {
        unsubscribeFromChannel();
      };

      // Private methods
      function unsubscribeFromChannel() {
        if (that.channel && that.channel.dispose) {
          that.channel.dispose();
        }
      }

      function updateMyQueryFromQueryManagementService() {
        if (that.managementId) {
          var fromManagement = NotesQueryManagementService.getIdState(that.managementId);
          if (that.subscription.uninitialized) {
            that.subscription = fromManagement
          } else {
            that.subscription.query = fromManagement.query;
          }
        } else {
          console.error(that.subscriberName + ': cannot get query, no management ID was set. Have you forgotten to call initialize()?');
        }
      }

      function subscribeToUpdates() {
        if (that.subscription && that.subscription.subject) {
          that.channel = that.subscription.subject
            .filter(function(obj) {
              return obj.queryUpdate;
            }).subscribe(function(obj) {
              that.updateMyself();
          });
        } else {
          console.error(that.subscriberName + ': Internal error, cannot subscribe to updates without being initialized.');
        }
      }

      var registerQueryChange = _.throttle(function() {
        NotesQueryManagementService.registerQueryChange(that.managementId, that.subscription.query);
      }, 250);

    }]);
